<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (criteriaFormGroup) {
  <ng-container [formGroup]="criteriaFormGroup">
    <table class="mat-mdc-table" formArrayName="fields">
      <tr class="mat-mdc-header-row">
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Field</th>
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Operator</th>
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Search for</th>
        <th class="mat-mdc-header-cell mdc-data-table__header-cell">Example</th>
      </tr>
      @for (searchField of criteriaFormGroup.get('fields')['controls']; track searchField; let i = $index) {
        <tr class="mat-mdc-row" [formGroupName]="i">
          <td class="mat-mdc-cell">
            <div class='search-row-text'>
              <div class='search-row-text-item'>{{criteria.fields[i].fieldValue.display}}</div>
            </div>
          </td>
          <td class="mat-mdc-cell search-operator">
            <mat-form-field>
              <mat-select [formControlName]="criteria.fields[i].operator.name" [compareWith]="compareOpValues">
                @for (op of criteria.fields[i].operator.operators; track op.type) {
                  <mat-option
                  [value]="op.type">{{op.display}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
          <td class="mat-mdc-cell search-value">
            @switch (criteria.fields[i].fieldValue.uitype) {
              @case ('input') {
                <mat-form-field>
                  <input matInput type="text" [formControlName]="criteria.fields[i].fieldValue.name"/>
                </mat-form-field>
              }
              @case ('dropdown') {
                <mat-form-field>
                  <mat-select [formControlName]="criteria.fields[i].fieldValue.name">
                    <mat-option [value]="undefined">-- Select --</mat-option>
                    @for (opt of criteria.fields[i].fieldValue.listitems; track opt) {
                      <mat-option
                      [value]="opt.value">{{opt?.display}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @case ('date') {
                <mat-form-field>
                  <input matInput
                    [formControlName]="criteria.fields[i].fieldValue.name"
                    [matDatepicker]="dataFormDatePicker">
                  <mat-datepicker-toggle matSuffix [for]="dataFormDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #dataFormDatePicker></mat-datepicker>
                </mat-form-field>
              }
            }
          </td>
          <td class="mat-mdc-cell search-example">
            <div class='search-row-text'>
              <button mat-button type="button" class="button-link search-row-text-item" (click)="fillFromExample(criteria.fields[i], i)">
                {{criteria.fields[i].fieldValue.example}}
              </button>
            </div>
          </td>
        </tr>
      }
    </table>
    <!--<div><pre>{{criteriaFormGroup.get('fields')|json}}</pre></div>-->
  </ng-container>
}
